import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { EsnCandidatService } from './../../../../core/services/esn-candidat/esn-candidat.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  EmptyCV,
  obligationSelect,
  serverError,
} from './../../../../core/models/messages';
import { EsnJobOfferService } from './../../../../core/services/esn-job-offer-service/esn-job-offer.service';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { SortDataService } from './../../../../core/services/sortdata';
import { Country, IState, State } from 'country-state-city';
import * as saveAs from 'file-saver';
import * as JSZip from 'jszip';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { translations } from '../../../../core/models/call-offer';
import { PageEvent } from '@angular/material/paginator';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-suggestion',
  templateUrl: './suggestion.component.html',
  styleUrls: ['./suggestion.component.css'],
})
export class SuggestionComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  isFormSubmitted: boolean = false;
  freeSearch: boolean = false;
  isFreeSearchFromSubmitted: boolean = false;
  activeForm: 'freeSearch' | 'guidedSearch' | null = null;
  dataHeader: any = [];
  private unsubscribeAll: Subject<void> = new Subject();
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];
  Statut: { id: string; name: string }[] = [
    { id: '1', name: 'actif' },
    { id: '2', name: 'inactif' },
  ];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  poste = [
    { id: 1, name: 'sur site' },
    { id: 2, name: 'à distance' },
    { id: 3, name: 'hybrid' },
  ];
 
  searchForm: FormGroup = this.createSearchForm();
  freeSearchForm: FormGroup = this.createFreeSearchForm();
  idoffre = this.activatedRoute.snapshot.params['id'];
  connectedUser = this.localStorageService.getData('userConnected');
  loadSpinner: boolean = false;
  pagination : boolean =false;

  idappel: any;
  itemsPerPage: number = 5;
  currentPage: number = 0;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  listNames: string[] = [];
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listappeloffre: any;
  sortAttr = '';
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  currentSortColumn: string = 'name';
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  countries: any = [];
  stateList!: IState[];
  backGroundColors: string[] = [
    'blue',
    'orange',
    'bleu-clair',
    'pink',
    'rose',
    'jaune',
    'rouge',
  ];
  selectedUserId!: string;
  nameEsn = this.localStorageService.getData('clientConnectedName');
  isCollapsed = true;
  iduser: any;
  listconsultant: any;
  skillsList: { name_FR: string }[] = [];
  listsuggestion: any;
  ischecked = true;
  selectedCandidats: any = [];
  isLoadSpinner: boolean = true;
  startSearching:boolean = false;
  candidateScoreDetail : any = null

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private salarieservice: SalarieService,
    private jobofferservice: EsnJobOfferService,
    private activatedRoute: ActivatedRoute,
    private candidatservice: EsnCandidatService,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.countries = Country.getAllCountries();
    this.getListSkills();
    this.getListsuggestion();
    this.getListElementHeader();
    // this.getlistconsultant()
  }

  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchsuggestion();
      }else if(this.isFreeSearchFromSubmitted){
        this.freeSearchsuggestion();
      }else {
        this.getListsuggestion();
      }
    }
  }
getListElementHeader() {
      this.jobofferservice
        .getHeaderElements(34)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
             this.dataHeader.map((el: any) => {
              if (el.name.toLowerCase() === 'score barème' && el.checked_user === null) {
                return (el.checkAdmin = false);
              } else if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
  }
  
  
  changeSelection(event: any, data: any, i: number) {
    if(data?.name?.toLowerCase() ==="score barème" && event.target.checked){
      Swal.fire({
            title: `Conformément à la réglementation RGPD, cette fonctionnalité ne peut être activée que si vous avez reçu plus de 50 candidatures. Souhaitez-vous continuer ?`,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Confirmer',
            cancelButtonText: 'Annuler',
            reverseButtons: true,
            iconColor: '#265D91',
            confirmButtonColor: '#265D91',
          }).then((result) => {
            if (result.isConfirmed) {
              this.toastrService.success('La colonne "Score Barème" a été activée avec succès.');
              this.listNames = [];
              data.checkAdmin = event.target.checked;
              for (const iterator of this.dataHeader) {
                if (iterator.checkAdmin) this.listNames.push(iterator.name);
              }
              this.changeSelectionHeadrElements(data);
            } else {
              event.target.checked = false; // Annuler la sélection
              data.checkAdmin = false;
              this.listNames = [];
              for (const iterator of this.dataHeader) {
                if (iterator.checkAdmin) this.listNames.push(iterator.name);
              }
            }
          });
    } else{
      this.listNames = [];
      data.checkAdmin = event.target.checked;
      for (const iterator of this.dataHeader) {
        if (iterator.checkAdmin) this.listNames.push(iterator.name);
      }
      this.changeSelectionHeadrElements(data);
  
    }
  }
  
  changeSelectionHeadrElements(data: any) {
    let payload = {
      sub_page_id: data?.id,
      state: data?.checkAdmin? 1 : 0,
    };
      this.jobofferservice
        .changeDelectedElementHeader(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
  }
  onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      this.searchForm.get('city')?.setValue(null);
    }
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }

  getListsuggestion() {
    this.loadSpinnerTable = true
    const params = {
      job_offer_id: this.idoffre,
      per_page: this.pageSize,
      page: this.currentPage
    }   
    this.spinner.show()
    this.jobofferservice.getListsuggestion(params).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          this.listsuggestion = response.data.data
          this.totalItems = response.data.total;
          this.loadSpinnerTable = false;
          this.spinner.hide();
        }
      },
      error: (error: any) => {
        this.spinner.hide();
        this.loadSpinnerTable = false
        const message = error.error.message || serverError;
        this.toastrService.error(message);
      },
    });
  }
  translateCountryName(name: string): string {

    return translations[name] || name;
  }
  sortData(item: string) {
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    let sort = { sort: this.currentSortDirection, sortAttribute: item };
    this.sortAttr = item;
    if (this.searchForm.dirty)
      this.listsuggestion = this.sortDataService.sortArray(
        this.listsuggestion,
        item,
        this.currentSortDirection
      );
    else this.getListsuggestion();
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      name: ['', data?.name],
      post: ['', data?.post],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      manager_name: ['', data?.manager_name],
      client_final_name: ['', data?.client_final_name],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      tjm_vente: ['', data?.tjm_vente],
      tjm_vente_range: ['', data?.tjm_vente_range],
      tjm_achat: ['', data?.tjm_achat],
      tjm_achat_range: ['', data?.tjm_achat_range],
      max_experience_years: ['', data?.max_experience_years],
      min_experience_years: ['', data?.min_experience_years],
      mobility: [[], data?.mobility],
      country: [null, data?.country],
      availability: [[], data?.availability],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
      per_page: this.pageSize,
      page: this.currentPage,
    });
  }

  createFreeSearchForm(data?: any) {
    return this.formBuilder.group({

      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }

  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }

 alreadyConverted = false;
 convertKToNumber(value: any): number {
  if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
    // Si la valeur se termine par 'k'
    const numericValue = parseFloat(value.slice(0, -1));
    if (!isNaN(numericValue)) {
      // Convertir en multipliant par 1000
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return numericValue * 1000;
    }
  } else if (!isNaN(value)) {
    // Si la valeur est déjà un nombre
    if (!this.alreadyConverted) {
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return parseFloat(value) * 1000;
    } else {
      return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
    }
  }

  // Si aucune condition n'est remplie, retourner une valeur par défaut
  return 0; // Ou une autre valeur par défaut appropriée
}
  /* search */
  searchsuggestion() {
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(
      valueForm.desired_salary_range?.toString()
    );
    let data = {
      name: valueForm.name,
      post: valueForm.post,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      manager_name: valueForm.manager_name,
      client_final_name: valueForm.client_final_name,
      tjm_achat: valueForm.tjm_achat,
      tjm_achat_range: valueForm.tjm_achat_range,
      tjm_vente: valueForm.tjm_vente,
      tjm_vente_range: valueForm.tjm_vente_range,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      max_experience_years: valueForm.max_experience_years,
      min_experience_years: valueForm.min_experience_years,
      mobility: valueForm.mobility,
      country: valueForm.country,
      per_page: this.pageSize,
      page: this.currentPage + 1,
      availability: valueForm.availability,
      job_offer_id: this.idoffre,
    };

    this.jobofferservice.searchconsultantsuggestionjoboffre(data).subscribe({
      next: (resSearch) => {
        this.totalItems = resSearch.data.total;
        this.startSearching = false;
        this.spinner.hide();
        this.listsuggestion = resSearch.data.data;
      },
      error: (error) => {
        const message = error.error.message || serverError;
        this.toastrService.error(message);
      },
    });
  }

  freeSearchsuggestion(pageNumber : number = this.currentPage) {
    let valueForm = this.freeSearchForm.value;
    let data = {
      sort: this.currentSortDirection,
      per_page: this.itemsPerPage,
      page: pageNumber,
      search: this.transformSearch(valueForm?.search),
      job_offer_id: this.idoffre,
    }; 
    this.jobofferservice.freeSearchconsultantsuggestionjoboffre(data).subscribe({
      next: (resSearch) => {
        this.totalItems = resSearch.data.total;
        this.startSearching = false;
        this.spinner.hide();
        this.listsuggestion = resSearch.data.data;
      },
      error: (error) => {
        const message = error.error.message || serverError;
        this.toastrService.error(message);
      },
    });
  }
onPageChange(e: PageEvent): void {
  this.pageSize = e.pageSize;
  this.currentPage = e.pageIndex;
   if (this.searchForm.dirty) {
    this.searchsuggestion();
  } 
  else if (this.freeSearchForm.dirty){
    this.freeSearchsuggestion();
  }
  else {
    this.getListsuggestion();
  }
}
getClass(item: string): string {
  if (item === 'Nom') {
    return 'th-fixed';
  } 
  return '';
}
getRemainingPays(pay: any): string {
  if (!Array.isArray(pay) || pay.length <= 3) {
    return ''; 
  }
 // console.log(pay.map(m => String(m)).join(', '))
  return pay.map(m => String(m)).join(', '); 
}
  setActiveForm(form: 'freeSearch' | 'guidedSearch') {
    // Si aucun formulaire n'est actif, activer le formulaire cliqué
    if (this.activeForm === null) {
      this.activeForm = form;
    }
      // Désactiver le formulaire non actif
      if (form === 'freeSearch') {
        this.freeSearchForm.enable(); // Activer le formulaire libre
       
      } else if (form === 'guidedSearch') {
        this.searchForm.enable(); // Activer le formulaire guidé
     
      }
  }

  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchsuggestion();
  }

  onSubmit() {
    console.log("this.activeForm", this.activeForm);
    if (this.activeForm === 'freeSearch') {
      this.currentPage = 0;
      this.freeSearchsuggestion();
    } else {
      this.currentPage = 0;
      this.searchsuggestion();
    }
  }
  getContractTypeList(contractTypes: number[]): string {
    const contractMap: { [key: string]: string } = {
        '1': 'Alternance',
        '2': 'Autres type de contrat',
        '3': 'CDD',
        '4': 'CDI',
        '5': 'Freelance',
        '6': 'Portage salarial',
        '7': 'Stage'
    };

    return Object.keys(contractTypes).map(type => contractMap[type.toString()] || '').join(', ');
  }
  onReset() {
    this.stateList=[];
    this.currentPage = 0;
    this.freeSearchForm.reset();
    this.freeSearchForm = this.createFreeSearchForm();
    this.searchForm = this.createSearchForm();
    this.getListsuggestion();
  }

  resetFreeSearch() {
    this.currentPage = 1;
    this.freeSearchForm.reset();
    this.freeSearchForm = this.createFreeSearchForm();
    this.freeSearchForm.get('search')?.reset();
    this.isFreeSearchFromSubmitted = false;
  }

  resetAdvancedSearch() {
    this.currentPage = 1;
    this.searchForm.reset();
    this.isFormSubmitted = false;
  }

  displayFreeSearch() {
    this.freeSearch = !this.freeSearch;
    if(this.freeSearch) {
       this.searchForm = this.createSearchForm();
       this.searchForm.reset();
       this.getListsuggestion();
       this.activeForm = 'freeSearch';
    }
    else {
      this.freeSearchForm.reset();
      this.freeSearchForm = this.createFreeSearchForm();
      this.getListsuggestion();
      this.activeForm = 'guidedSearch'
    }
  }


  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }
  downloadFile(type: string, candidat?: any, typeFile?: string) {
    if (this.ischecked) {
      if (type == 'single' && candidat) {
        if (candidat.cv || candidat.file_test) {
          if (typeFile && typeFile != '')
            candidat.file_test = candidat.file_test.split('/')[1];
          const fileUrl = !typeFile
            ? `${this.url}/User/file/gallery_cvs/${candidat.cv}`
            : `${this.url}/ResponseCandidate/GetFile/${candidat.file_test}`; // Replace with your file URL
          this.showGlobalSpinner();
          this.candidatservice.downloadPDF(fileUrl).subscribe(
            (data) => {
              const blob = new Blob([data], {
                type: 'application/octet-stream',
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = !typeFile
                ? `${candidat.first_name}_${
                    candidat.last_name
                  }_CV.${candidat!.cv.split('.').pop()}`
                : `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_QCM.${candidat!.file_test.split('.').pop()}`;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              this.hideGlobalSpinner();
            },
            () => {
              this.hideGlobalSpinner();
            }
          );
        } else {
          this.toastrService.info(EmptyCV);
        }
      } else if (this.selectedCandidats.length) {
        if (
          this.selectedCandidats.length == 1 &&
          !this.selectedCandidats[0].cv
        ) {
          this.toastrService.info(EmptyCV);
        } else this.downloadPdfFiles(typeFile);
      } else {
        this.toastrService.info(obligationSelect);
      }
    } else {
      this.toastrService.error(
        'Limite de téléchargements atteinte. Vous ne pouvez télécharger que 3 fichiers.'
      );
    }
  }
  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }
  /* download files in zip folder */
  downloadPdfFiles(typeFile?: string) {
    const zip = new JSZip();
    const fileUrls = this.selectedCandidats.map(
      (el: {
        cv: string;
        file_test: string;
        first_name: string;
        last_name: string;
        ID_user: string;
      }) => {
        if (!typeFile) {
          return {
            url: `${this.url}/User/file/gallery_cvs/${el.cv}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            cv: el.cv,
          };
        } else {
          // if(el.file_test!=null)
          return {
            url: `${this.url}/ResponseCandidate/GetFile/${
              el?.file_test?.split('/')[1]
            }`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            response: el?.file_test?.split('/')[1],
          };
        }
      }
    );
    this.showGlobalSpinner();
    const downloadPromises = fileUrls.map((pdfUrl: any) => {
      return this.candidatservice
        .getPdfContent(pdfUrl.url)
        .toPromise()
        .then(
          (pdfContent: any) => {
            this.hideGlobalSpinner();
            zip.file(
              !typeFile
                ? `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_CV.${pdfUrl.cv.split('.').pop()}`
                : `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_QCM.${pdfUrl.response.split('.').pop()}`,
              pdfContent
            );
          },
          (err: any) => {
            this.hideGlobalSpinner();
          }
        );
    });

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        if (!typeFile) {
          saveAs(content, 'RH_Profiles_CVs.zip'); // Specify the zip file name here
        } else {
          saveAs(content, 'RH_Profiles_QCMs.zip');
        }
      });
    });
  }
  postuleroffre() {
    let data = {
      user_id: this.selectedUserId,
      job_request_id: this.idappel,
    };
    this.jobofferservice.postuleroffre(data).subscribe({
      next: (res: any) => {
        this.toastrService.success(
          'votre candidature a été envoyé avec succès.'
        );
      },
      error: (error) => {
        if (error.error.message === 'candidature already exist.') {
          this.toastrService.error('Candidature existe déjà');
        }
        if (error.error.message === 'the job offer has been deactivated.') {
          this.toastrService.error(
            "La postulation n'est pas autorisée car l'appel d'offres est désactivé."
          );
        }
      },
    });
  }
  open(suggestion: any) {
    this.idappel = suggestion.id;
  }

  getconsultantid(e: any, userId: string) {
    if (e.target.checked) {
      this.selectedUserId = userId;
      // Décocher toutes les autres cases sauf celle qui a été cochée
      this.deselectOtherCheckboxes(userId);
    }
  }
  deselectOtherCheckboxes(currentUserId: string) {
    // Parcourir la liste des consultants et décocher les cases sauf celle qui a été cochée
    // Assurez-vous que this.consultants est la liste de vos consultants
    this.listconsultant.forEach((consultant: any) => {
      if (consultant.id !== currentUserId) {
        consultant.checked = false; // Ajoutez une propriété "checked" à votre objet consultant si elle n'existe pas
      }
    });
  }

   // @TOFIX : duplicated
   /**
   * Returns a string list of skills for tooltip display.
   * @param contractTypes - An array of skills.
   * @returns A string listing the skills names.
   */
   getSkillsList(skillsList: string[]): string {
    if(Array.isArray(skillsList))  return skillsList.map(skill => skill).join(', ');
    else return ''
  }

  closeModalScore() {
    let btnClose = document.getElementById('ModalCloseScore');
    if (btnClose) {
      btnClose.click();
    }
  }

  openModalScore(idCandidate : string){
    this.jobofferservice.getDetailScore(this.idoffre, idCandidate).subscribe({
      next: (res: any) => {
        this.candidateScoreDetail = res?.data;
        console.log('this.candidateScoreDetail',this.candidateScoreDetail)

      },
      error: (error) => {
      },
    });

  }
}
